import { AHText, Box, useTheme } from "arkh";
import React, { useEffect, useRef } from "react";

import { useKeyboardInModal } from "./useKeyboardInModal";
import { FormattedMessage } from "react-intl";
import { Lottie, LottieRef } from "../../components/Lottie";

const FileSearchNoFilesFound_ = () => {
  const ref = useRef<LottieRef>(null);
  const [keyboardBottomInset, { onLayout }] = useKeyboardInModal();
  const theme = useTheme();
  useEffect(() => {
    ref.current?.play();
  }, []);

  return (
    <Box
      spaceHorizontal="large"
      spaceVertical="xlarge"
      onLayout={onLayout}
      style={{ paddingBottom: keyboardBottomInset, flex: 1 }}
    >
      <AHText type="title" style={{ textAlign: "center" }}>
        <FormattedMessage
          defaultMessage="We could not find any files matching your query"
          description="Files no search reasults description"
        />
      </AHText>
      <Box style={{ flex: 1, alignItems: "center" }}>
        <Lottie
          ref={ref}
          source={require("./spilled-file.json")}
          autoPlay
          loop
          speed={1}
          hardwareAccelerationAndroid
          colorFilters={[
            { color: theme.primary, keypath: "milk/fil Outlines" },
          ]}
        />
      </Box>
    </Box>
  );
};
export const FileSearchNoFilesFound = React.memo(FileSearchNoFilesFound_);
